import { baseUrl, headers } from 'api';

export const getAreaInteresseSelect = async () => {
  const response = await fetch(`${baseUrl}/curriculo/area-interesse/`, {
    method: 'GET',
    headers: {
      ...headers,
      Authorization: sessionStorage.getItem('@senac:token'),
    },
  });

  return response;
};
